// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"06c592ee","36":"0c81e4aa","425":"8e6f276e","545":"825bbae8","685":"cf5758f6","890":"0677466e"}[chunkId] + ".chunk.js";
};